import {useQuery} from '@tanstack/react-query';
import {ICommentsViewListResponse} from '../../api/types/document.type';
import {getCommentsViewList} from '../../api/endpoints/documentApi';

export const useCommentsViewList = (isFetchRequired: boolean) => {
  return useQuery<ICommentsViewListResponse, Error>({
    queryKey: ['commentsViewList'],
    queryFn: getCommentsViewList,
    enabled: isFetchRequired,
  });
};
